export default __webpack_public_path__ + "static/media/4.13429c53.png";